import { ref, computed } from 'vue';
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, Fragment as _Fragment, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-8aea5fe8"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "drawer-title"
};
const _hoisted_2 = {
  key: 0
};
const _hoisted_3 = {
  key: 0
};
const _hoisted_4 = {
  key: 0
};
const _hoisted_5 = {
  key: 0
};
const _hoisted_6 = {
  key: 0
};
const _hoisted_7 = {
  key: 0
};
const _hoisted_8 = {
  key: 0
};
const _hoisted_9 = {
  key: 0
};
const _hoisted_10 = ["onClick"];
const _hoisted_11 = ["onClick"];
const _hoisted_12 = ["onClick"];
const _hoisted_13 = ["onClick"];
import { message } from 'ant-design-vue';
import { getIndicatorSettingListFetch, saveIndicatorSettingFetch } from '@/api/orderMonitor';
import { reportEvent } from '@/common';
// const emit = defineEmits(["reflashTable"]);

export default {
  __name: 'IndicatorSettingModal',
  setup(__props, {
    expose
  }) {
    const drawVisible = ref(false);
    const loading = ref(false);
    const tableData = ref([]);
    const currentSchemeId = ref(null);
    const currentSchemeName = ref('');
    const editingIndex = ref(-1);
    const originalDataMap = ref(new Map()); // 保存原始数据，用于取消时恢复

    const columns = ref([{
      title: '指标类型',
      dataIndex: 'indicatorName',
      key: 'indicatorName',
      width: '150px',
      fixed: 'left'
    }, {
      title: '相对异常上限',
      dataIndex: 'relativeAnomalyUpperLimit',
      key: 'relativeAnomalyUpperLimit',
      width: '120px'
    }, {
      title: '相对异常下限',
      dataIndex: 'relativeAnomalyLowerLimit',
      key: 'relativeAnomalyLowerLimit',
      width: '120px'
    }, {
      title: '异常变化相对值',
      dataIndex: 'relativeValueOfAnomalyChange',
      key: 'relativeValueOfAnomalyChange',
      width: '140px'
    }, {
      title: '保底值上限',
      dataIndex: 'minimumValueUpperLimit',
      key: 'minimumValueUpperLimit',
      width: '120px'
    }, {
      title: '保底值下限',
      dataIndex: 'minimumValueLowerLimit',
      key: 'minimumValueLowerLimit',
      width: '120px'
    }, {
      title: '斜率上限',
      dataIndex: 'slopeUpperLimit',
      key: 'slopeUpperLimit',
      width: '120px'
    }, {
      title: '斜率下限',
      dataIndex: 'slopeLowerLimit',
      key: 'slopeLowerLimit',
      width: '120px'
    },
    // {
    //   title: "状态",
    //   dataIndex: "enable",
    //   key: "enable",
    //   width: "100px",
    // },
    {
      title: '操作',
      key: 'action',
      dataIndex: 'action',
      align: 'right',
      width: '130px',
      fixed: 'right'
    }]);
    const showModal = async record => {
      drawVisible.value = true;
      currentSchemeId.value = record.schemeId;
      currentSchemeName.value = record.schemeName || '';
      await getIndicatorList();
    };
    const onClose = () => {
      drawVisible.value = false;
      tableData.value = [];
      currentSchemeId.value = null;
      currentSchemeName.value = '';
      editingIndex.value = -1;
      originalDataMap.value.clear();
    };
    const getIndicatorList = async () => {
      try {
        loading.value = true;
        const {
          code,
          data
        } = await getIndicatorSettingListFetch({
          schemeId: currentSchemeId.value
        });
        if (code === '0') {
          tableData.value = (data === null || data === void 0 ? void 0 : data.thresholdIndicatorList) || [];
          // 清空原始数据映射
          originalDataMap.value.clear();
        }
        return code === '0' ? 'succeed' : 'failed';
      } catch (e) {
        return 'failed';
      } finally {
        loading.value = false;
      }
    };

    // 可编辑的阈值字段：提交时将 undefined/null 转为 ''，以便接口能清空数据库
    const THRESHOLD_FIELDS = ['relativeAnomalyUpperLimit', 'relativeAnomalyLowerLimit', 'relativeValueOfAnomalyChange', 'minimumValueUpperLimit', 'minimumValueLowerLimit', 'slopeUpperLimit', 'slopeLowerLimit'];

    // 构建保存参数：阈值字段的 undefined/null 转为 ''，其余空值不传
    const buildSaveParams = (record, extra = {}) => {
      const result = {
        ...record,
        ...extra
      };
      THRESHOLD_FIELDS.forEach(key => {
        if (result[key] === undefined || result[key] === null) {
          result[key] = '';
        }
      });
      Object.keys(result).forEach(key => {
        if (!THRESHOLD_FIELDS.includes(key) && (result[key] === null || result[key] === undefined || result[key] === '')) {
          delete result[key];
        }
      });
      return result;
    };
    const editRow = (record, index) => {
      // 如果已经有其他行在编辑，先取消编辑
      if (editingIndex.value !== -1 && editingIndex.value !== index) {
        const prevRecord = tableData.value[editingIndex.value];
        cancelEdit(prevRecord, editingIndex.value);
      }

      // 保存原始数据
      originalDataMap.value.set(record.indicatorId, JSON.parse(JSON.stringify(record || {})));

      // 设置为编辑状态
      editingIndex.value = index;
    };
    const saveRow = async record => {
      try {
        const params = buildSaveParams(record, {
          schemeId: currentSchemeId.value
        });
        const {
          code
        } = await saveIndicatorSettingFetch(params);
        if (code === '0') {
          message.success('保存成功');
          // 清除原始数据
          originalDataMap.value.delete(record.indicatorId);
          // 退出编辑状态
          editingIndex.value = -1;
          // 刷新列表
          await getIndicatorList();
          reportEvent({
            eventName: 'element_use',
            properties: {
              ui_name: '阀值方案-指标设置',
              element_name: '保存'
            }
          });
        } else {
          message.error('保存失败');
        }
      } catch (e) {
        message.error('保存失败');
      }
    };
    const cancelEdit = (record, index) => {
      // 恢复原始数据
      const originalData = originalDataMap.value.get(record.indicatorId);
      if (originalData) {
        tableData.value[index] = {
          ...tableData.value[index],
          ...originalData
        };
        // 清除原始数据
        originalDataMap.value.delete(record.indicatorId);
      }
      // 退出编辑状态
      editingIndex.value = -1;
    };
    const toggleStatus = async record => {
      // 保存原始状态，用于失败时恢复
      const originalStatus = record.enable;
      // 乐观更新：切换状态 (1=开启, 0=关闭)
      const newStatus = record.enable == 1 ? 0 : 1;
      record.enable = newStatus;
      try {
        const params = buildSaveParams(record, {
          schemeId: currentSchemeId.value,
          enable: newStatus
        });
        const {
          code
        } = await saveIndicatorSettingFetch(params);
        if (code === '0') {
          message.success(newStatus == 1 ? '已开启' : '已关闭');
          reportEvent({
            eventName: 'element_use',
            properties: {
              ui_name: '阀值方案-指标设置',
              element_name: newStatus == 1 ? '开启' : '关闭'
            }
          });
        } else {
          // 如果失败，恢复原状态
          record.enable = originalStatus;
        }
      } catch (e) {
        // 如果失败，恢复原状态
        record.enable = originalStatus;
      }
    };
    const drawerTitle = computed(() => {
      return `指标设置-${currentSchemeName.value || ''}`;
    });
    expose({
      showModal
    });
    return (_ctx, _cache) => {
      const _component_a_input_number = _resolveComponent("a-input-number");
      const _component_a_table = _resolveComponent("a-table");
      const _component_a_modal = _resolveComponent("a-modal");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_a_modal, {
        placement: "right",
        width: "1200px",
        open: drawVisible.value,
        "onUpdate:open": _cache[0] || (_cache[0] = $event => drawVisible.value = $event),
        class: "indicator-draw",
        onClose: onClose,
        footer: null
      }, {
        title: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("span", null, _toDisplayString(_unref(drawerTitle)), 1)])]),
        default: _withCtx(() => [_createVNode(_component_a_table, {
          size: "small",
          columns: columns.value,
          dataSource: tableData.value,
          rowKey: "indicatorId",
          loading: loading.value,
          pagination: false,
          class: "table-content"
        }, {
          bodyCell: _withCtx(({
            column,
            record,
            index
          }) => {
            var _record$relativeAnoma, _record$relativeAnoma2, _record$relativeValue, _record$minimumValueU, _record$minimumValueL, _record$slopeUpperLim, _record$slopeLowerLim;
            return [column.dataIndex === 'indicatorName' ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(record.indicatorName), 1)) : _createCommentVNode("", true), column.dataIndex === 'relativeAnomalyUpperLimit' ? (_openBlock(), _createElementBlock(_Fragment, {
              key: 1
            }, [editingIndex.value !== index ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString((_record$relativeAnoma = record.relativeAnomalyUpperLimit) !== null && _record$relativeAnoma !== void 0 ? _record$relativeAnoma : '--'), 1)) : (_openBlock(), _createBlock(_component_a_input_number, {
              key: 1,
              value: record.relativeAnomalyUpperLimit,
              "onUpdate:value": $event => record.relativeAnomalyUpperLimit = $event,
              placeholder: "请输入",
              class: "number-input"
            }, null, 8, ["value", "onUpdate:value"]))], 64)) : _createCommentVNode("", true), column.dataIndex === 'relativeAnomalyLowerLimit' ? (_openBlock(), _createElementBlock(_Fragment, {
              key: 2
            }, [editingIndex.value !== index ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString((_record$relativeAnoma2 = record.relativeAnomalyLowerLimit) !== null && _record$relativeAnoma2 !== void 0 ? _record$relativeAnoma2 : '--'), 1)) : (_openBlock(), _createBlock(_component_a_input_number, {
              key: 1,
              value: record.relativeAnomalyLowerLimit,
              "onUpdate:value": $event => record.relativeAnomalyLowerLimit = $event,
              placeholder: "请输入",
              class: "number-input"
            }, null, 8, ["value", "onUpdate:value"]))], 64)) : _createCommentVNode("", true), column.dataIndex === 'relativeValueOfAnomalyChange' ? (_openBlock(), _createElementBlock(_Fragment, {
              key: 3
            }, [editingIndex.value !== index ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString((_record$relativeValue = record.relativeValueOfAnomalyChange) !== null && _record$relativeValue !== void 0 ? _record$relativeValue : '--'), 1)) : (_openBlock(), _createBlock(_component_a_input_number, {
              key: 1,
              value: record.relativeValueOfAnomalyChange,
              "onUpdate:value": $event => record.relativeValueOfAnomalyChange = $event,
              placeholder: "请输入",
              class: "number-input"
            }, null, 8, ["value", "onUpdate:value"]))], 64)) : _createCommentVNode("", true), column.dataIndex === 'minimumValueUpperLimit' ? (_openBlock(), _createElementBlock(_Fragment, {
              key: 4
            }, [editingIndex.value !== index ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString((_record$minimumValueU = record.minimumValueUpperLimit) !== null && _record$minimumValueU !== void 0 ? _record$minimumValueU : '--'), 1)) : (_openBlock(), _createBlock(_component_a_input_number, {
              key: 1,
              value: record.minimumValueUpperLimit,
              "onUpdate:value": $event => record.minimumValueUpperLimit = $event,
              placeholder: "请输入",
              class: "number-input"
            }, null, 8, ["value", "onUpdate:value"]))], 64)) : _createCommentVNode("", true), column.dataIndex === 'minimumValueLowerLimit' ? (_openBlock(), _createElementBlock(_Fragment, {
              key: 5
            }, [editingIndex.value !== index ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString((_record$minimumValueL = record.minimumValueLowerLimit) !== null && _record$minimumValueL !== void 0 ? _record$minimumValueL : '--'), 1)) : (_openBlock(), _createBlock(_component_a_input_number, {
              key: 1,
              value: record.minimumValueLowerLimit,
              "onUpdate:value": $event => record.minimumValueLowerLimit = $event,
              placeholder: "请输入",
              class: "number-input"
            }, null, 8, ["value", "onUpdate:value"]))], 64)) : _createCommentVNode("", true), column.dataIndex === 'slopeUpperLimit' ? (_openBlock(), _createElementBlock(_Fragment, {
              key: 6
            }, [editingIndex.value !== index ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString((_record$slopeUpperLim = record.slopeUpperLimit) !== null && _record$slopeUpperLim !== void 0 ? _record$slopeUpperLim : '--'), 1)) : (_openBlock(), _createBlock(_component_a_input_number, {
              key: 1,
              value: record.slopeUpperLimit,
              "onUpdate:value": $event => record.slopeUpperLimit = $event,
              placeholder: "请输入",
              class: "number-input"
            }, null, 8, ["value", "onUpdate:value"]))], 64)) : _createCommentVNode("", true), column.dataIndex === 'slopeLowerLimit' ? (_openBlock(), _createElementBlock(_Fragment, {
              key: 7
            }, [editingIndex.value !== index ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString((_record$slopeLowerLim = record.slopeLowerLimit) !== null && _record$slopeLowerLim !== void 0 ? _record$slopeLowerLim : '--'), 1)) : (_openBlock(), _createBlock(_component_a_input_number, {
              key: 1,
              value: record.slopeLowerLimit,
              "onUpdate:value": $event => record.slopeLowerLimit = $event,
              placeholder: "请输入",
              class: "number-input"
            }, null, 8, ["value", "onUpdate:value"]))], 64)) : _createCommentVNode("", true), column.dataIndex === 'action' ? (_openBlock(), _createElementBlock(_Fragment, {
              key: 8
            }, [editingIndex.value === index ? (_openBlock(), _createElementBlock(_Fragment, {
              key: 0
            }, [_createElementVNode("a", {
              onClick: $event => saveRow(record)
            }, "保存", 8, _hoisted_10), _createElementVNode("a", {
              class: "m-l-12",
              onClick: $event => cancelEdit(record, index)
            }, "取消", 8, _hoisted_11)], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
              key: 1
            }, [_createElementVNode("a", {
              onClick: $event => editRow(record, index)
            }, "编辑", 8, _hoisted_12), _createElementVNode("a", {
              class: "m-l-12",
              onClick: $event => toggleStatus(record)
            }, _toDisplayString(record.enable == 1 ? '关闭' : '开启'), 9, _hoisted_13)], 64))], 64)) : _createCommentVNode("", true)];
          }),
          _: 1
        }, 8, ["columns", "dataSource", "loading"])]),
        _: 1
      }, 8, ["open"])]);
    };
  }
};